function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon/account-default",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_account_2394286",
  transform: "translate(8.000000, 5.000000)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9997225,2 C16.2412298,2 20.0213433,4.67574328 21.431024,8.67623713 C22.8407046,12.676731 21.5732076,17.1313459 18.2686463,19.7904054 C16.4965666,21.2282515 14.2817147,22.0088888 11.9997225,22 C6.47702825,22 2,17.5227882 2,11.9999618 C2,6.47713541 6.47702825,2 11.9997225,2 Z M19.1859919,16.8433811 L19.186003,16.8433811 C21.6219502,13.2293882 20.9952864,8.36854214 17.7223908,5.49057263 C14.4494951,2.61260313 9.54853587,2.6128206 6.2758956,5.49108056 C3.00325532,8.36934052 2.3770229,13.2302422 4.81329081,16.8440189 C5.28973092,15.3604623 6.76103009,14.1246959 8.73647971,13.4668895 C9.57602315,14.3794972 10.7593683,14.8988151 11.9993869,14.8988354 C13.2394054,14.8988557 14.4227675,14.3795764 15.2623408,13.4669962 C17.2372349,14.1247359 18.7090918,15.3601712 19.1859919,16.8433811 Z M11.9995336,13.7877283 C10.0121712,13.7877283 8.40109568,11.9950644 8.40109568,9.78370139 C8.40109568,7.57233838 10.0121712,5.77967446 11.9995336,5.77967446 C13.986896,5.77967446 15.5979715,7.57233838 15.5979715,9.78370139 C15.5979715,11.9950644 13.986896,13.7877283 11.9995336,13.7877283 Z",
  id: "Combined-Shape",
  fill: "#5F6368",
  fillRule: "nonzero"
}));

var SvgAccountDefault = function SvgAccountDefault(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccountDefault, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account-default.2bfe1e7d.svg";
export { ForwardRef as ReactComponent };